import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppContainer from 'containers/AppContainer';
import configureStore from 'store/configureStore';
import nodeConfig from 'configs/nodeConfig';
import configHelper from 'helper/Config/configHelper';

const { baseUrl } = configHelper.getConfig();
const { env = 'development' } = nodeConfig;

require('../src/css/main.less');
if (env === 'development') {
    require('webpack-hot-middleware/client');
}


/* global document */

const { store } = configureStore(),
    requireAll = (r) => {
        r.keys().forEach(r);
    };

if (env !== 'development') {
    requireAll(require.context('../public/svg', true, /\.svg$/));
} else {
    fetch(`${baseUrl}/hotel/icons.svg`, {
        method: 'GET'
    }).then(res => {
        return res.text();
    }).then(data => {
        document.getElementById('svg-icons').innerHTML = data;
    });
}

ReactDOM.createRoot(document.getElementById('app'))
    .render(
        <React.StrictMode>
            <Provider store={store}>
                <BrowserRouter>
                    <AppContainer />
                    <div className="overlay__wrapper"></div>
                </BrowserRouter>
            </Provider>
        </React.StrictMode>
    );

